export const GET_ASSETS = 'GET_ASSETS';
export const CREATE_ASSET = 'CREATE_ASSET';
export const UPDATE_ASSET = 'UPDATE_ASSET';
export const DELETE_ASSET = 'DELETE_ASSET';
export const FILTER_WAVEFORMS = 'FILTER_WAVEFORMS';
export const FILTER_SENSATIONS = 'FILTER_SENSATIONS';
export const SET_SELECTED_ASSET = 'SET_SELECTED_ASSET';
export const CLEAR_SELECTED_ASSET = 'CLEAR_SELECTED_ASSET';
